import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SectionDivider } from './SectionDivider';
function FaqItem({
  title,
  children,
  isOpen,
  onClick
}: {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border-b border-white/10" data-id="element-161">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" onClick={onClick} data-id="element-162">
        <span className={`text-lg font-medium transition-colors ${isOpen ? 'text-[#c9a84c]' : 'text-white group-hover:text-[#c9a84c]'}`} data-id="element-163">
          {title}
        </span>
        <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#c9a84c]' : 'text-white/50'}`} data-id="element-164" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-165">
        <p className="text-white/70 leading-relaxed" data-id="element-166">{children}</p>
      </div>
    </div>;
}
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: "What's included in the €249 package?",
    a: 'Full custom website build, mobile responsive design, contact form, WhatsApp integration, Google Maps, basic analytics, 1-year Hobby plan ($180 value), 100 monthly AI editing requests, and up to 3 rounds of revisions.'
  }, {
    q: 'What about hosting and domain?',
    a: "Domain registration and hosting are paid separately if needed. We'll help you set everything up and recommend affordable options."
  }, {
    q: 'How fast will my website be ready?',
    a: 'Typically within 48 hours after we receive all your content (text, images, logo). The faster you send materials, the faster we deliver.'
  }, {
    q: 'How many revisions do I get?',
    a: 'Up to 3 rounds of revisions are included. After that, you can use your 100 monthly AI requests to make changes yourself.'
  }, {
    q: 'Can I edit the website myself after launch?',
    a: 'Yes! Your plan includes 100 AI-assisted editing requests per month. Just describe what you want changed and the AI handles it.'
  }, {
    q: 'Is this only for Dublin businesses?',
    a: "We prioritize Dublin businesses for faster, more personal support. However, we're happy to work with businesses in other locations too."
  }, {
    q: "What if I need more than what's included?",
    a: 'We can discuss additional features or pages at a fair price. Just ask!'
  }];
  return <section id="faq" className="py-16 px-4 md:px-6" style={{
    backgroundColor: '#080808'
  }} data-id="element-167">
      <div className="max-w-3xl mx-auto" data-id="element-168">
        <div className="text-center mb-12 reveal" data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-170">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-2 reveal" data-id="element-171">
          {faqs.map((faq, idx) => <FaqItem key={idx} title={faq.q} isOpen={openIndex === idx} onClick={() => setOpenIndex(openIndex === idx ? null : idx)} data-id="element-172">
              {faq.a}
            </FaqItem>)}
        </div>
      </div>
      <SectionDivider data-id="element-173" />
    </section>;
}